<template>
  <div>
  <div v-if="!isNewNote">
    <div class="form-row">
      <div style="text-align: left; padding-bottom: 1px">
        <ejs-button type="button" cssClass="e-info" v-on:click.native="onAddNoteClick">
          <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" /> Add Notes
        </ejs-button>
      </div>
    </div>
    <ejs-grid :dataSource="userNotes" ref="refNotesList"
    :created="created"
    :enablePersistence="false"
      :selection-settings="selectionOptions"
      :commandClick="commandClick"
      :allowSorting="true"
      :allowPaging="true" :pageSettings="pageSettings" :toolbar="toolbarOptions">
      <e-columns>
        <e-column headerText="Action" width="10%"
        :commands="editCommand" textAlign="Left" />
        <e-column field="lastModifiedDate" type="date" :format="gridDateFormat"
          width="10%" headerText="Date" textAlign="Left" />
        <e-column field="summary" width="35%" headerText="Summary" textAlign="Left" />
        <!-- <e-column field="description" width="25%"
        headerText="Description" textAlign="Left" /> -->
        <e-column field="lastModifiedBy" width="35%"
          headerText="Last Update User" textAlign="Left" />
        <e-column headerText="Delete" width="10%"
          :commands="deleteCommand" textAlign="Left" />
      </e-columns>
    </ejs-grid>
  </div>
  <div v-else>
    <save-user-notes ref="refUserNotes"
      :user-profile-id="userProfileId" :user-note="userNoteData"
      @IsNewNoteVal="setNewNote($event)" @RebindGrid="refreshGrid($event)">
    </save-user-notes>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from "@syncfusion/ej2-vue-grids";
import { DialogUtility } from '@syncfusion/ej2-popups';
import SaveUserNotes from "./user-notes-save.vue";
import { FETCH_USER_NOTES, DELETE_USER_NOTES } from '../store';
import { getDataGridDateFormat } from '../../../utils/date-utils';

Vue.use(ButtonPlugin);
Vue.use(GridPlugin);
Vue.use(DialogUtility);

export default {
  name: 'UserNotesList',
  async created() {
    await this.getNotesList();
  },
  components: {
    SaveUserNotes,
  },
  props: {
    userProfileId: String,
  },
  data() {
    return {
      isNewNote: false,
      selectionOptions: {
        type: "Single",
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      // notes: [],
      userNoteData: {
        userID: this.userProfileId,
        summary: null,
        description: null,
        lastModifiedBy: null,
        lastModifiedDate: null,
      },
      DialogObj: null,
      toolbarOptions: ["Search"],
      pageSettings: { pageSize: 10 },
      editCommand: [
        {
          type: "Action",
          buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
        },
      ],
      deleteCommand: [
        {
          type: "Delete",
          buttonOption: {
            cssClass: 'e-flat deletebtn',
            iconCss: 'e-delete e-icons',
          },
        },
      ],
      gridDateFormat: getDataGridDateFormat(),
    };
  },
  computed: {
    ...mapGetters({
      userNotes: 'userNotes',
    }),
  },
  methods: {
    notify(type, message) {
      this.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    onAddNoteClick() {
      this.isNewNote = true;
      this.userNoteData.id = null;
      this.userNoteData.userID = this.userProfileId;
      this.userNoteData.summary = null;
      this.userNoteData.description = null;
      this.userNoteData.lastModifiedBy = null;
      this.userNoteData.lastModifiedDate = null;
    },
    commandClick(args) {
      this.userNoteData = {
        id: args.rowData.id,
        userID: this.userProfileId,
        summary: args.rowData.summary,
        description: args.rowData.description,
        lastModifiedBy: args.rowData.lastModifiedBy,
        lastModifiedDate: args.rowData.lastModifiedDate,
      };

      switch (args.commandColumn.type) {
        case 'Delete':
          this.DialogObj = DialogUtility.confirm({
            title: 'Delete Notes',
            content: 'Are you sure you want to delete this notes?',
            okButton: { text: 'OK', click: this.deleteNotes },
            cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' },
          });
          break;
        case 'Action':
          this.isNewNote = true;
          break;
        default:
          break;
      }
    },
    async deleteNotes() {
      const id = this.userNoteData?.id;
      await this.$store
        .dispatch(DELETE_USER_NOTES, id)
        .then(() => {
          this.refreshGrid(true);
          this.notify('Success!', 'Notes deleted successfully.');
          this.hideDeleteDialog();
        })
        .catch((error) => {
          console.error(`postdelete_err:${error.Status}`);
          this.hideDeleteDialog();
          DialogUtility.alert(error.message);
        });
    },
    hideDeleteDialog() {
      this.DialogObj.hide();
    },
    created() {
      this.isNewNote = false;
    },
    setNewNote(val) {
      this.isNewNote = val;
    },
    async refreshGrid(rebind) {
      if (rebind) {
        await this.getNotesList();
      }
    },
    async getNotesList() {
      try {
        const userId = this.userProfileId;
        await this.$store.dispatch(FETCH_USER_NOTES, { userId });
      } catch (err) {
        console.error(err);
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>
